<sim-basic-material-dialog
	(closeClicked)="closeDialog()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-user-friends', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_CREATE_PEER_PRACTICE_SESSION | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-component-loading-container [isLoading]="isLoading()" [showBackDrop]="true" loadingIcon="fad fa-cube" />

		<mat-stepper #sessionStepper [linear]="true" labelPosition="bottom" orientation="horizontal">
			@if (!isLoading()) {
				<ng-template matStepperIcon="edit">
					<mat-icon fontIcon="fa-check" fontSet="fal" inline />
				</ng-template>

				<!--STEP 1-->
				<mat-step [completed]="stateService.metadataForm.valid" [editable]="true" [stepControl]="stateService.metadataForm">
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_METADATA_AND_STATIONS | translate }}
					</ng-template>

					<ng-template matStepContent>
						<sim-peer-practice-session-step1 [eventEndDate]="data.eventEndDate" [eventStartDate]="data.eventStartDate" />
					</ng-template>
				</mat-step>

				<!--STEP 2-->
				<mat-step [editable]="true" [completed]="stateService.session()?.userSubGroups?.length">
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_GROUP_SELECTION | translate }}
					</ng-template>
					<ng-template matStepContent>
						<sim-peer-practice-session-step2 />
					</ng-template>
				</mat-step>

				<!--STEP 3-->
				<mat-step [editable]="true">
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_PP_SCHEDULE | translate }}
					</ng-template>
					<ng-template matStepContent>
						<sim-peer-practice-session-step3 />
					</ng-template>
				</mat-step>
			}
		</mat-stepper>
	</ng-container>

	<ng-container actions>
		<!--AUTOSAVE-->
		<!--TODO: define warning message-->
		<sim-autosave-widget
			[promise]="stateService.savePromise()"
			[timestamp]="stateService.session()?.lastUpdateTime"
			[warningMessage]="null"
		/>

		<!--NAV BUTTONS-->
		@if (sessionStepper?.selectedIndex !== 2) {
			<sim-button
				(onClick)="sessionStepper.next()"
				[disabled]="!sessionStepper.selected?.completed"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-step-forward'}"
				[label]="T.BUTTON_NEXT"
				color="accent"
			/>
		} @else {
			<sim-button
				(onClick)="closeDialog()"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_FINISH"
				color="accent"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
